import React from 'react';
import PropTypes from 'prop-types';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Checkbox } from '@mui';
import SortIconButton from '@shared/data-table/header/sort-icon-button';
import Cell from './cell';
import './head.scss';

const getColumnWidth = width => width ? ({
  maxWidth: `${width}rem`,
  minWidth: `${width}rem`,
  width: `${width}rem`
}) : {};

const Head = ({ checkedProps, columns, dataType, onToggleAll, stickyFirstColumn, subType }) => (
  <TableHead>
    <TableRow>
      {columns.map((column, columnIndex) => {
        const isFirstColumn = columnIndex === 0 && stickyFirstColumn;
        const style = {
          ...getColumnWidth(column.width),
          ...(column.style || {}),
          whiteSpace: 'nowrap',
          ...(isFirstColumn && {
            position: 'sticky',
            left: 0,
            zIndex: 3 // Above other header cells (stickyHeader uses z-index 2)
          })
        };
        if (column.key === 'checkbox') {
          const { isAllChecked, isAnyChecked } = checkedProps;
          return (
            <Cell key={`header-${column.key}`} style={style}>
              <Checkbox
                checked={isAnyChecked}
                indeterminate={isAnyChecked && !isAllChecked}
                onChange={onToggleAll}
                onClick={event => event.stopPropagation()}
                size="small"
              />
            </Cell>
          );
        }
        // Only show sort button if dataType is provided and column has ordering
        const showSort = dataType && column.ordering;
        return (
          <Cell key={`header-${column.key}`} style={style}>
            <div styleName="header-cell-wrapper">
              <span>{column.label}</span>
              {showSort && (
                <SortIconButton
                  column={column}
                  dataType={dataType}
                  subType={subType}
                />
              )}
            </div>
          </Cell>
        );
      })}
    </TableRow>
  </TableHead>
);

Head.propTypes = {
  checkedProps: PropTypes.object,
  columns: PropTypes.array,
  dataType: PropTypes.string,
  onToggleAll: PropTypes.func,
  stickyFirstColumn: PropTypes.bool,
  subType: PropTypes.string
};

export default Head;
